// extracted by mini-css-extract-plugin
export default {"markdown":"EledoArticleView_markdown__8gH1Z","sidebar":"EledoArticleView_sidebar__JJ-4p"};